export default function variant({
  img = {},
  size,
  ratio
}) {
  if (!size) return img.url;
  let variant;
  if (ratio) {
    variant = img.variants?.find(variant => variant.size === size && variant.ratio === ratio);
  } else {
    variant = img.variants?.find(variant => variant.size == size);
  }
  return variant?.url || img.url;
}
